import { KinerjaTipeContext } from 'app/KinerjaShared/hooks/useKinerjaTipeContext'

import type { KinerjaTipe } from 'types/kinerja'

type KinerjaTipeProviderProps = {
  tipe: KinerjaTipe
  children: React.ReactNode
}

/**
 * Provides content for the KinerjaTipeContext.
 *
 * @param {KinerjaTipe} tipe - The actor type
 * @param {React.ReactNode} children - The child components.
 */
export function KinerjaTipeProvider({
  tipe,
  children,
}: KinerjaTipeProviderProps) {
  return (
    <KinerjaTipeContext.Provider value={{ tipe }}>
      {children}
    </KinerjaTipeContext.Provider>
  )
}
